import { useField } from 'react-final-form'
import { composeValidators, textRequired } from '../../utilities/validate'
import { UseTextfieldProps } from '../textfield/textfieldType'
import useTranslate from '../../i18n/useTranslate'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

function useRichTextfield(props: UseTextfieldProps) {
    const { name, required, validates = [] } = props
    const translate = useTranslate()

    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            textRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M015')}`),
            ...mergeValidate,
        ]
    }
    /* Validate */
    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useRichTextfield
